import React from "react";
import { cn } from "@/lib/utils";

interface LiveBadgeProps {
  className?: string;
  variant?: "default" | "glow" | "pulse";
}

export const LiveBadge: React.FC<LiveBadgeProps> = ({ 
  className, 
  variant = "default" 
}) => {
  return (
    <div
      className={cn(
        "relative flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold uppercase tracking-wide",
        variant === "glow" && "shadow-[0_0_12px_rgba(239,68,68,0.6)]",
        "bg-gradient-to-r from-red-500 to-orange-500 text-white",
        className
      )}
    >
      {/* Animated dot */}
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-white" />
      </span>
      
      <span>Live</span>
      
      {/* Glow effect */}
      {variant === "glow" && (
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-red-500 to-orange-500 blur-md opacity-50 -z-10 animate-pulse" />
      )}
    </div>
  );
};

export default LiveBadge;
